module.exports = __webpack_public_path__ + "img/valuationbanner3.5ec64f63.png";